const colors = {
  mention: 'var(--c-mention)',
  unread: 'var(--c-secondary-text)',
  mutedUnread: 'var(--c-secondary-text)',
};

export default colors;
